<div class="container">
  <div class="headerContainer">
    <h1><b>Issue Tracker</b></h1>
  </div>

  <div class="content">
    <ag-grid-angular
      style="width: 100%; height: 70vh"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      (gridReady)="onGridReady($event)"
      [theme]="theme"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClicked($event)"
    />
    

  <div class="grid-actions" *ngIf="!isLoading">
    <mat-checkbox 
      [(ngModel)]="showClosedTickets" 
      (change)="onShowClosedChange()"
      class="show-closed-checkbox">
      Show Closed Tickets
    </mat-checkbox>
  </div>
</div>